import Reveal from "@/components/base/Reveal";
import { whatsappLink } from "@/constants/site";

const STRIP = [
  "Sites",
  "Hospedagem",
  "VPS",
  "Lojas Virtuais",
  "SEO",
  "Marketing",
  "Google Ads",
];

export default function CriaSiteFinalCta() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="absolute inset-0 nx-grid opacity-20"></div>
      <div className="nx-glow absolute -bottom-32 left-1/2 h-[420px] w-[420px] -translate-x-1/2 animate-pulseGlow"></div>

      <div className="relative mx-auto max-w-4xl px-4 text-center md:px-8">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-300">
            <i className="ri-rocket-2-line" aria-hidden="true"></i>
            Presença digital profissional
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight md:text-4xl">
            Vamos criar uma presença digital à altura da sua empresa?
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-200">
            Conte um pouco sobre seu negócio e solicite uma prévia inicial sem custo. Você poderá
            conhecer uma proposta visual antes de decidir os próximos passos.
          </p>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#previa"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-bold uppercase tracking-wide text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-image-add-line text-lg" aria-hidden="true"></i>
              Solicitar minha prévia
            </a>
            <a
              href={whatsappLink("Ola! Quero falar com um especialista da NXHOST sobre criacao de sites.")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-6 py-3.5 text-sm font-bold uppercase tracking-wide text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
              Falar com especialista
            </a>
          </div>
          <p className="mt-4 text-xs text-background-400">
            Prévia inicial sem custo • Sem compromisso de contratação
          </p>
        </Reveal>

        <Reveal delay={160}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border-t border-background-50/10 pt-8 text-xs font-medium uppercase tracking-wide text-background-400">
            {STRIP.map((item, index) => (
              <span key={item} className="flex items-center gap-3">
                {item}
                {index < STRIP.length - 1 ? (
                  <span className="text-primary-400" aria-hidden="true">
                    •
                  </span>
                ) : null}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}